class SafeStorage {
  constructor(storageType) {
    this.storage = null;
    if (typeof window === 'undefined' || !window[storageType]) {
      return;
    }
    this.storage = storageType === 'localStorage' ? window.localStorage : window.sessionStorage;
  }
  getItem(key) {
    try {
      var _this$storage$getItem, _this$storage;
      return (_this$storage$getItem = (_this$storage = this.storage) === null || _this$storage === void 0 ? void 0 : _this$storage.getItem(key)) !== null && _this$storage$getItem !== void 0 ? _this$storage$getItem : null;
    } catch (err) {
      return null;
    }
  }
  setItem(key, value) {
    try {
      var _this$storage2;
      (_this$storage2 = this.storage) === null || _this$storage2 === void 0 || _this$storage2.setItem(key, value);
    } catch (err) {
      // fail silently
    }
  }
  removeItem(key) {
    try {
      var _this$storage3;
      (_this$storage3 = this.storage) === null || _this$storage3 === void 0 || _this$storage3.removeItem(key);
    } catch (err) {
      // fail silently
    }
  }
  clear() {
    try {
      var _this$storage4;
      (_this$storage4 = this.storage) === null || _this$storage4 === void 0 || _this$storage4.clear();
    } catch (err) {
      // fail silently
    }
  }
  key(index) {
    try {
      var _this$storage$key, _this$storage5;
      return (_this$storage$key = (_this$storage5 = this.storage) === null || _this$storage5 === void 0 ? void 0 : _this$storage5.key(index)) !== null && _this$storage$key !== void 0 ? _this$storage$key : null;
    } catch (err) {
      return null;
    }
  }
  get length() {
    try {
      var _this$storage$length, _this$storage6;
      return (_this$storage$length = (_this$storage6 = this.storage) === null || _this$storage6 === void 0 ? void 0 : _this$storage6.length) !== null && _this$storage$length !== void 0 ? _this$storage$length : 0;
    } catch (err) {
      return 0;
    }
  }
}
export const safeLocalStorage = new SafeStorage('localStorage');
export const safeSessionStorage = new SafeStorage('sessionStorage');